import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import LoadingComponent from '../core/LoadingComponent/LoadingComponent';
import TruncateComponent from '../core/TruncateComponent/TruncateComponent';

import './home.scss';

class HomeComponent extends React.Component {
    componentWillMount() {
        const { getCompanies } = this.props;

        getCompanies();
    }

    render() {
        const { isLoading, companies, onCompanySelect } = this.props;

        if (isLoading) {
            return <LoadingComponent fullScreen />;
        }

        return <div className="home">
            <h3>Select Company</h3>
            <span>Please select which company's API information you would like to access.</span>
            <div className="companies">
                {companies.map(({ name, firebaseId }, index) =>
                    <Button className="company" key={index} onClick={() => onCompanySelect(firebaseId)}>
                        <TruncateComponent lines={2} text={name} />
                    </Button>
                )}
            </div>
        </div>;
    }
}

HomeComponent.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    companies: PropTypes.array.isRequired,
    getCompanies: PropTypes.func.isRequired,
    onCompanySelect: PropTypes.func.isRequired,
};

export default HomeComponent;



// WEBPACK FOOTER //
// ./src/components/home/HomeComponent.js